import React from "react";
import "../App.css";

/* ======================================================
   CHECKPOINT COMPONENT (DEFINE FIRST)
====================================================== */

function JourneyCheckpoint({ icon, title, subtitle, items, isFinal }) {
  return (
    <div className={`checkpoint ${isFinal ? "final" : ""}`}>
      <div className="checkpoint-icon">{icon}</div>

      <div className="checkpoint-content">
        <h3 className="checkpoint-title">{title}</h3>
        <p className="checkpoint-subtitle">{subtitle}</p>

        <ul className="checkpoint-list">
          {items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

/* ======================================================
   MAIN PAGE
====================================================== */

export default function HowToBecomeMember() {
  return (
    <div className="main-container">
      {/* Header */}
      <h2 className="section-title">
        🚀 Start Your IYC Membership Journey
      </h2>

      <p className="journey-intro">
        Becoming a member of the Indian Youth Congress is a guided journey.
        Follow the checkpoints below using the official IYC mobile application.
        Each stage ensures authenticity, participation, and completion.
      </p>

      {/* Journey Timeline */}
      <div className="journey-timeline">
        <JourneyCheckpoint
          icon="📱"
          title="Get Ready"
          subtitle="Set up your access"
          items={[
            "Download the official IYC mobile application",
            "Login using your mobile number and verify via OTP",
            "Navigate to Election → Membership",
          ]}
        />

        <JourneyCheckpoint
          icon="🧾"
          title="Identity Verification"
          subtitle="Confirm member authenticity"
          items={[
            "Create a batch and add member details",
            "Upload a clear image of the physical Voter ID card",
            "Upload a recent smiling photograph (blink capture required)",
            "Record a short verification video saying full name and “Youth Congress”",
          ]}
        />

        <JourneyCheckpoint
          icon="🗳️"
          title="Participation"
          subtitle="Make your voice count"
          items={[
            "Cast all 6 votes as instructed in the app",
            "Ensure votes are successfully recorded",
            "Sync the batch after completing entries",
          ]}
        />

        <JourneyCheckpoint
          icon="🏁"
          title="Membership Activated"
          subtitle="Final confirmation"
          items={[
            "Complete membership payment immediately after sync",
            "Wait for confirmation inside the application",
            "Membership is active only after successful payment",
          ]}
          isFinal
        />
      </div>

      {/* Important Notes */}
      <div className="journey-notes">
        <h3>⚠️ Important Notes</h3>
        <ul>
          <li>Ensure all details match official documents exactly</li>
          <li>Upload clear photos and videos to avoid rejection</li>
          <li>Delays in sync or payment may invalidate the batch</li>
        </ul>
      </div>
    </div>
  );
}
